import type { ResourceDataFileResourceListResponseApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { ArtifactSimpleResource } from '@ingenico/react-form-builder';

export function mapArtifactsListForFormBuilderResponse(
  response: ResourceDataFileResourceListResponseApi,
): ArtifactSimpleResource[] {
  return response.data.map((artifact) => ({
    id: artifact.id,
    name: artifact.name,
    extension: artifact.artifact.extension,
  }));
}
